import { render } from "./EditAddress.vue?vue&type=template&id=e3259b24&ts=true"
import script from "./EditAddress.vue?vue&type=script&lang=ts"
export * from "./EditAddress.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__